<template>
  <div class="panel">
    <div class="panel-header">
      <div class="panel-header-left">
        <slot name="left">
          <img class="panel-icon" :src="iconSrc">
          <div class="panel-title">{{ title }}</div>
        </slot>
      </div>
      <div class="panel-header-right">
        <slot name="right" />
      </div>
    </div>
    <div class="panel-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    title: String
  },

  computed: {
    iconSrc() {
      if (this.icon) {
        return require(`../${this.icon}`)
      }

      return this.icon
    }
  }
}
</script>

<style lang='scss' scoped>
.panel {
    .panel-header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            border-bottom: 1px solid #F0F0F0;
        }
        .panel-header-left {
            position: relative;
            display: flex;
            align-items: center;
            padding: 0 0 0 30px;
            .panel-icon {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);
            }
            .panel-title {
                font-size: 16px;
                line-height: 18px;
                font-weight: bold;
            }
        }
    }
}
</style>
